import CreateTruck from "./CreateTruck";

export default CreateTruck;
